import { Col, Row } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { headerTitles } from "../../actions/masterdata/masterdata";
import { get_all_payments } from "../../actions/z_accounts";
import credit from "../../assets/icons/credit.png";
import debit from "../../assets/icons/debit.png";
import BankShow from "../Common/BankShow";
import TableComponent from "../Common/TableComp/TableComp";
import { p_types } from "../Payments/SendMoney/Recipients";
import CustomStatement from "./StatementSelect";
import usePayAxios from "../../config/useAxios";
import { gridApis } from "../../config/GridApis";
import { saveAs } from "file-saver";

const Banks = ({ hasWriteAccess }) => {
  const dispatch = useDispatch();
  const [isFilterSelected, setIsFilterSelected] = useState(false);

  const [account, setAccount] = useState("");
  const [accountObj, setAccountObj] = useState({});
  const [filterValue, setFilterValue] = useState("all");
  const [filterDetails, setFilterDetails] = useState({});
  const [page, setPage] = useState(1);
  const { t } = useTranslation();
  const data = useSelector(
    (state) => state?.z_accs?.all_payments?.data?.data ?? []
  );
  const loading = useSelector((state) => state?.z_accs?.all_payments?.loading);
  const totalRecords = useSelector(
    (state) => state?.z_accs?.all_payments?.data?.total_count ?? []
  );

  const { onCall, loading: pdfLoading } = usePayAxios({
    type: "grid",
    api: gridApis.fetchStatementsPDF,
    method: "post",
  });
  useEffect(() => {
    dispatch(
      headerTitles({
        title: t("statements"),
        description: t("find_records"),
      })
    );
    dispatch(get_all_payments({}));
  }, []);

  const columns = [
    {
      title: t("txn_id"),
      dataIndex: "transaction_ref_no",
      key: "transaction_ref_no",
    },
    {
      title: t("beneficiary_name"),
      dataIndex: "beneficiary_details",
      key: "beneficiary_details",
      render: (text, rec) =>
        text?.beneficiary_name
          ? text?.beneficiary_name
          : rec?.counterparty_account_name,
    },
    {
      title: t("beneficiary_account"),
      dataIndex: "counterparty_account_number",
      key: "counterparty_account_number",
    },
    {
      title: t("Date and Time"),
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => <div>{moment(text).format("DD, MMM YY, HH:mm")}</div>,
    },
    {
      title: "Payment Method",
      dataIndex: "transfer_mode",
      key: "transfer_mode",
      render: (text) => p_types?.find((ele) => ele.value === text)?.label,
    },

    {
      title: t("Amount"),
      dataIndex: "amount",
      key: "amount",
      render: (text, rec) => <div>₹{text}</div>,
    },
    {
      title: "Txn Type",
      dataIndex: "transaction_type",
      key: "transaction_type",
      render: (text) => (
        <span
          style={{
            color: "#333",
            textTransform: "capitalize",
          }}
        >
          <img src={text === "credit" ? credit : debit} width={10} /> {text}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <span className={`status status_${text?.toLowerCase()}`}>{text}</span>
      ),
    },
  ];
  // const columns = [
  //   {
  //     title: t("txn_id"),
  //     dataIndex: "accountTransactionId",
  //     key: "accountTransactionId",
  //   },
  //   {
  //     title: t("beneficiary_name"),
  //     dataIndex: "counterparty",
  //     key: "counterparty",
  //     render: (text) => <div>{text?.name}</div>,
  //   },
  //   {
  //     title: t("beneficiary_account"),
  //     dataIndex: "counterparty",
  //     key: "counterparty",
  //     render: (text) => <div>XXXX{text?.accountNumber?.value?.substr(4)}</div>,
  //   },
  //   {
  //     title: t("mode_of_payment"),
  //     dataIndex: "labels",
  //     key: "labels",
  //     render: (text) => <div>{text?.join(", ")}</div>,
  //   },

  //   {
  //     title: t("date"),
  //     dataIndex: "postingDate",
  //     key: "postingDate",
  //   },
  //   {
  //     title: t("Amount"),
  //     dataIndex: "amount",
  //     key: "amount",
  //     render: (text, r) => (
  //       <div>
  //         {currencyMapper[r.currencyCode]} {amountFormat(text)}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: t("transaction_type"),
  //     dataIndex: "directionCode",
  //     key: "directionCode",
  //     render: (text) => (
  //       <div className={`status_${text?.toLowerCase()}`}>
  //         {text === "IN"
  //           ? "Credit"
  //           : text === "OUT"
  //           ? "Debit"
  //           : text?.replace(/_/g, " ")}
  //       </div>
  //     ),
  //   },
  // ];

  const handleBankShowRefresh = () => {};
  return (
    <>
      {!isFilterSelected ? (
        <CustomStatement
          setSelectedAccount={setIsFilterSelected}
          account={account}
          setAccount={setAccount}
          setAccountObj={setAccountObj}
          setFilterDetails={setFilterDetails}
        />
      ) : (
        <>
          <Row wrap={false} className="table-wrapper">
            <Col flex="auto" className="table-wrapper-col">
              <div className="flex-grow">
                {filterValue === "all" ? (
                  <div className="mt1">
                    <BankShow
                      handleBankShowRefresh={handleBankShowRefresh}
                      handleBack={() => {
                        setIsFilterSelected(false);
                      }}
                      setAccountObj={setAccountObj}
                      dates={[filterDetails?.date_from, filterDetails?.date_to]}
                      accountId={accountObj?.id}
                      setFilterDetails={setFilterDetails}
                      account={`${
                        accountObj?.account_name?.length > 8
                          ? `${accountObj?.account_name?.substr(0, 8)}...`
                          : accountObj?.account_name
                      }
                      - XXXXX${accountObj?.account_number?.slice(-4)}`}
                      date={`${moment(filterDetails?.date_from).format(
                        "MMM DD,YY"
                      )} - ${moment(filterDetails?.date_to).format(
                        "MMM DD,YY"
                      )}`}
                      pdfLoading={pdfLoading}
                      onDownload={() => {
                        onCall({
                          params: {
                            account_id: accountObj?.id,
                            format: "pdf",
                          },
                          data: {
                            account_id: accountObj?.id,
                            statement_start_date: moment(
                              filterDetails?.date_from
                            ).format("YYYY-MM-DD"),
                            statement_end_date: moment(
                              filterDetails?.date_to
                            ).format("YYYY-MM-DD"),
                          },
                        }).then(async (res) => {
                          if (res?.data?.statement_file_url) {
                            const blob = await fetch(
                              res?.data?.statement_file_url
                            ).then((res) => res.blob());
                            saveAs(blob, res?.data?.file_name);
                          }
                        });
                      }}
                    />
                  </div>
                ) : null}

                <div className="shimmer" style={{ paddingTop: "15px" }}>
                  <TableComponent
                    columns={columns}
                    loading={loading}
                    data={data}
                    hasCheckbox={false}
                    rowKey="bill_no"
                    pagination={{
                      total: totalRecords || 0,
                      current: page,
                      onChange: (pagee) => {
                        dispatch(
                          get_all_payments({
                            page_number: pagee,
                          })
                        );
                        setPage(pagee);
                      },
                    }}
                    callAction={(acc, s_date, e_date) => {
                      dispatch(
                        get_all_payments({
                          params: { account_id: acc },
                          filters: {
                            created_at: {
                              start_date: s_date,
                              end_date: e_date,
                            },
                          },
                        })
                      );
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
export default Banks;
